"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlert = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Alert_1 = require("./Alert");
var useAlert = function () {
    var ref = (0, react_1.useRef)(null);
    var mount = (0, jsx_runtime_1.jsx)(Alert_1.AlertMount, { ref: ref });
    var showAlert = function (content) {
        if (!ref.current) {
            if (content !== null) {
                console.warn("useAlert hook attempted to call a function from a null AlertMount ref");
            }
            return;
        }
        ref.current.showAlert(content);
    };
    var closeAlert = function () { return showAlert(null); };
    return [mount, showAlert, closeAlert];
};
exports.useAlert = useAlert;
